import AppImage from '@theme/components/atom/AppImage'
import AppTitle from '@theme/components/atom/AppTitle'
import HeadingLevel from '~/mixins/HeadingLevel'

export default {
  name: 'ArticleBox',
  mixins: [HeadingLevel],
  components: { AppImage, AppTitle },

  props: {
    article: { type: Object, required: true },
    forceLinkReadMore: { type: Boolean, default: false },
    imagePosition: {
      type: String,
      default() {
        return this.$themeSettings.components.ArticleBox.image.position
      },
    },

    lazyImage: { type: Boolean, default: false },
  },

  computed: {
    articleLink() {
      const slug = this.article?.page_meta?.slug
      return slug ? this.localePath({ name: 'article-slug', params: { slug } }) : '#'
    },
  },
}
